import { storage } from '../../../helpers'
import axios from 'axios'
import { API_URL } from '../../../config'

export const exportProcessToExcel = async (documentId) => {
  const token = storage.getToken()

  const response = await axios.post(
    `${API_URL}/documents/${documentId}/export`,
    {},
    {
      responseType: 'arraybuffer',
      headers: {
        Accept:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        Authorization: `Bearer ${token}`
      }
    }
  )

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  })

  const contentDisposition = response.headers['content-disposition']
  const fileNameMatch = contentDisposition?.match(/filename="(.+?)"/)
  const fileName = fileNameMatch
    ? fileNameMatch[1]
    : `export_procesare_document.xlsx`

  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  link.click()

  window.URL.revokeObjectURL(url)
}
